export const volumes = [
  {
    title: 'VOLUMEN 1 — Principios para Construir Acuerdos de Cuidado™',
    items: [
      'Identificás qué necesitás acordar realmente',
      'Separás hechos de suposiciones y reclamos',
      'Preparás una conversación sin improvisación',
      'Llegás con claridad antes de hablar',
    ],
    border: 'border-blue-400/30',
  },
  {
    title: 'VOLUMEN 2 — Método de Conversaciones para Llegar a Acuerdos™',
    items: [
      'Usás frases que abren diálogo sin acusar',
      'Presentás alternativas en vez de imposiciones',
      'Escuchás sin perder tu necesidad',
      'Cerrás conversaciones sin dejar tensión abierta',
    ],
    border: 'border-green-400/30',
  },
  {
    title: 'VOLUMEN 3 — Estrategias para Sostener Acuerdos de Cuidado™',
    items: [
      'Registrás qué se acordó de forma clara',
      'Revisás sin convertir todo en reproche',
      'Ajustás acuerdos cuando hace falta',
      'Mantenés los acuerdos vivos en el tiempo',
    ],
    border: 'border-amber-400/30',
  },
];

export const kitIncludes = [
  'Método de 14 días paso a paso',
  'Guiones listos para abrir cada conversación',
  'Matriz para llegar con alternativas concretas',
  'Registro de acuerdos imprimible',
];

export const bonuses = [
  {
    number: '01',
    title: 'Mapa Rápido del Desacuerdo™',
    detail:
      'Plantilla para ordenar una diferencia confusa y separar el tema real del tema aparente.',
    value: '$12.000',
  },
  {
    number: '02',
    title: 'Guiones de Apertura Sin Reproche™',
    detail:
      'Frases y scripts listos para iniciar, conducir y cerrar conversaciones difíciles.',
    value: '$10.000',
  },
  {
    number: '03',
    title: 'Matriz de Alternativas Posibles™',
    detail:
      'Herramienta para llegar con 3 opciones concretas en vez de una sola propuesta.',
    value: '$9.000',
  },
  {
    number: '04',
    title: 'Registro de Acuerdos Revisables™',
    detail:
      'Tracker imprimible para dejar escrito qué se acordó, cuándo se aplica y cuándo se revisa.',
    value: '$11.000',
  },
  {
    number: '05',
    title: 'Plan 10 Minutos Antes de Hablar™',
    detail:
      'Guía de preparación mental y emocional para los minutos previos a la conversación.',
    value: '$10.000',
  },
];

export const painPoints = [
  'Conversaciones que empiezan sobre un tema y terminan en reclamos.',
  'No sabés cómo plantear una propuesta sin sonar autoritaria.',
  'No encontrás un punto intermedio cuando los dos quieren cosas diferentes.',
  'Cada acuerdo se olvida o se reinterpreta después.',
  'Sensación de estar sola en las decisiones del cuidado.',
];

export const costs = [
  'Otro mes llegando a cada charla sin preparación',
  'Discusiones que generan tensión en el vínculo',
  'Acuerdos que se olvidan o se reinterpretan',
  'Sensación de estar sola en las decisiones',
  'Agotamiento emocional sin dirección clara',
];

export const faqs = [
  {
    question: '¿Necesito ser especialista en comunicación?',
    answer:
      'No. El kit te enseña paso a paso cómo conversar sobre temas del cuidado.',
  },
  {
    question: '¿Cuánto tiempo me toma?',
    answer:
      'Podés recorrer el método en 14 días, combinando los contenidos principales con la aplicación práctica de sus herramientas.',
  },
  {
    question: '¿Garantiza que mi familiar acepte todo?',
    answer:
      'El kit está diseñado para darte herramientas prácticas para preparar conversaciones, expresar tus necesidades y buscar acuerdos sin depender de la improvisación.',
  },
  {
    question: '¿Es 100% digital?',
    answer:
      'Sí. Acceso inmediato por email en PDF. Podés leerlo desde el celular, tablet o computadora, e imprimirlo si preferís.',
  },
  {
    question: '¿La garantía es real?',
    answer:
      'Sí. Tenés 14 días de garantía y podés solicitar la devolución dentro de ese período si el kit no es para vos.',
  },
  {
    question: '¿Puedo usar esto si no tengo un familiar con Párkinson?',
    answer:
      'El kit fue creado para mujeres que cuidan a un familiar con Párkinson y necesitan mejorar la comunicación y los acuerdos de cuidado.',
  },
];
